import { GroupDetailPageLayout } from '@/components/admin/groups/GroupDetailPageLayout';
import { PendingInvites } from '@/components/group-form/PendingInvites';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

const Page: React.FC = () => {
  return (
    <GroupDetailPageLayout>
      <PendingInvites />
    </GroupDetailPageLayout>
  );
};

export default restrictedRoute(Page, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});


